import React, { useEffect, useState } from "react";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { Brightness1 } from "@mui/icons-material";

import { CAP_LEVELS } from "../../domain/CapLevels";

const DEFAULT_CHIP_COLOR = 'darkgrey';

export default function ContentDetail({ contentInfo, compactView = true }) {

    const [capLevel, setCapLevel] = useState(null);
    const uniqueCapLevels = [...new Set(contentInfo.map(content => content.level))];
    const isSameCapLevel = uniqueCapLevels.length === 1;

    useEffect(() => {

        const filteredCapLevel = CAP_LEVELS.filter(level => level.key === contentInfo[0].level);

        setCapLevel(filteredCapLevel[0]);
    }, [contentInfo]);

    return (
        <Tooltip disableFocusListener arrow title={
            <Stack direction="column" alignItems="flex-start">
                {contentInfo.map((content, index) => (
                    <Typography key={index} variant="overline" color="white">
                        {content.name}
                    </Typography>
                ))}
            </Stack>
        }>
            <Chip size="small" icon={capLevel && <Brightness1 sx={{ "&&": { color: `${isSameCapLevel ? capLevel.color : DEFAULT_CHIP_COLOR}` } }} />}
                  sx={{ margin: '0.125rem', backgroundColor: 'rgba(255, 255, 255, 0.8)', minWidth: `${!compactView ? '2.688rem' : 'inherit'}` }} />
        </Tooltip>
    );
}